import { render, staticRenderFns } from "./min_amount.vue?vue&type=template&id=065ecdb2&"
import script from "./min_amount.vue?vue&type=script&lang=js&"
export * from "./min_amount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports